import { createSlice } from '@reduxjs/toolkit';

import { Token } from '@/types';

import { RootState } from '../store';

import { syncNativeAppContext } from './appSlice';

export interface AuthState {
  accessToken: Token | null;
}

const initialState: AuthState = {
  accessToken: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(syncNativeAppContext.fulfilled, (state, { payload }) => {
      state.accessToken = payload.token;
    });
  },
});

export default authSlice.reducer;

export const getAuthState = (state: RootState) => state.auth;

export const getIsAuthenticated = (state: RootState) => !!state.auth.accessToken;
